import { Home, Pencil, Wrench, Scale, Building, ArrowUpRight } from "lucide-react";

export default function Services() {
  const services = [
    {
      icon: Home,
      title: "Строительство домов",
      description:
        "Индивидуальное строительство домов от фундамента до отделки с высокой точностью и вниманием к деталям.",
      features: [
        "Индивидуальный проект",
        "Качественные материалы",
        "Соблюдение сроков",
      ],
    },
    {
      icon: Pencil,
      title: "Дизайн",
      description:
        "Архитектурный и интерьерный дизайн для создания эстетичных, удобных и функциональных пространств.",
      features: [
        "3D-визуализация",
        "Планирование пространства",
        "Подбор материалов",
      ],
    },
    {
      icon: Wrench,
      title: "Ремонт",
      description:
        "Профессиональный ремонт и реконструкция объектов — от локальных работ до комплексных переделок.",
      features: [
        "Быстрый отклик",
        "Профессиональный ремонт",
        "Гарантия на работы",
      ],
    },
    {
      icon: Scale,
      title: "Юридические услуги",
      description:
        "Сопровождение разрешений, документации и нормативных требований на всех этапах проекта.",
      features: [
        "Оформление разрешений",
        "Соблюдение норм",
        "Подготовка документов",
      ],
    },
    {
      icon: Building,
      title: "Недвижимость",
      description:
        "Поддержка в развитии, оценке и продаже объектов недвижимости с учётом рыночной экспертизы.",
      features: [
        "Анализ рынка",
        "Оценка имущества",
        "Поддержка продаж",
      ],
    },
  ];

  return (
    <section className="bg-[#fafaf9] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Header */}
        <div className="mb-20">
          <div className="flex items-center gap-4 mb-10">
            <span className="w-10 h-px bg-[#147f8f]" />
            <span className="text-sm font-bold tracking-[0.35em] uppercase text-[#147f8f]">
              Наши услуги
            </span>
          </div>

          <div className="grid lg:grid-cols-2 gap-10 items-end">
            <h2 className="text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-[-0.04em] text-slate-950">
              <span className="font-semibold block">
                Продуманные
              </span>
              <span className="font-light text-slate-500 block">
                решения для строительства.
              </span>
            </h2>

            <p className="text-lg md:text-xl leading-[1.8] text-slate-600 max-w-2xl lg:pb-3">
              Мы объединяем проектирование, строительство, ремонт и сопровождение
              недвижимости в единую систему — спокойно, точно и без лишнего.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {services.map((service, index) => {
            const Icon = service.icon;
            const number = String(index + 1).padStart(2, "0");

            return (
              <article
                key={index}
                className="group bg-white p-8 lg:p-10 min-h-[390px] flex flex-col justify-between transition-colors duration-300 hover:bg-slate-50"
              >
                <div>
                  <div className="flex items-start justify-between mb-12">
                    <div className="flex h-12 w-12 items-center justify-center border border-slate-200">
                      <Icon className="w-6 h-6 text-[#147f8f]" />
                    </div>

                    <span className="text-sm tracking-[0.25em] text-slate-400">
                      {number}
                    </span>
                  </div>

                  <h3 className="text-2xl font-semibold tracking-[-0.03em] text-slate-950 mb-5">
                    {service.title}
                  </h3>

                  <p className="text-slate-600 leading-relaxed max-w-sm">
                    {service.description}
                  </p>
                </div>

                <div className="mt-10">
                  <div className="h-px w-full bg-slate-200 mb-6" />

                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="flex items-center justify-between gap-4 text-sm text-slate-600"
                      >
                        <span>{feature}</span>
                        <span className="h-px w-5 bg-[#147f8f]/50 shrink-0" />
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}

          {/* Minimal CTA Card */}
          <article className="group bg-[#147f8f] p-8 lg:p-10 min-h-[390px] flex flex-col justify-between md:col-span-2 lg:col-span-1">
            <div>
              <span className="text-sm font-semibold tracking-[0.35em] uppercase text-[#76bb17]">
                Консультация
              </span>

              <h3 className="mt-10 text-3xl font-semibold tracking-[-0.04em] leading-tight text-white">
                Не знаете, с чего начать проект?
              </h3>

              <p className="mt-5 text-slate-300 leading-relaxed">
                Расскажите нам о задаче — мы подскажем оптимальный формат работ,
                сроки и следующий шаг.
              </p>
            </div>

            <a
              href="/contact"
              className="mt-10 inline-flex w-fit items-center gap-4 border border-white/20 px-6 py-4 text-white hover:bg-white hover:text-slate-950 transition-all duration-300"
            >
              Получить предложение
              <ArrowUpRight className="w-5 h-5" />
            </a>
          </article>
        </div>

      </div>
    </section>
  );
}